import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Produto, ProdutoKit } from 'src/app/models/produto';
import swal from 'sweetalert2';
import { CadastrarComposicaoKitModalComponent } from './cadastrar-composicao-kit-modal/cadastrar-composicao-kit-modal.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-composicao-kit-modal',
  templateUrl: './composicao-kit-modal.component.html',
  styleUrls: ['./composicao-kit-modal.component.scss']
})
export class ComposicaoKitModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  composicao: ProdutoKit[] = [];

  bloquear = false;

  constructor(public dialogRef: MatDialogRef<ComposicaoKitModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
    this.composicao = data.composicao;
    this.bloquear = data.bloquear;
  }

  ngOnInit() {
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar() {
    this.dialogRef.close(this.composicao);
  }

  adicionarComposicao() {
    const largura = Number(($('body').width()));

    // this.changeDetectorRef.detach();
    // setTimeout(() => this.tooltip.hide(200));

    const dialogRef = this.dialog.open(CadastrarComposicaoKitModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { editando: false, produtoKit: new ProdutoKit() },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.changeDetectorRef.reattach();
      if (result) {
        this.composicao.push(result);
      }
    });

  }

  editarComposicao(item: ProdutoKit) {
    const largura = Number(($('body').width()));

    // this.changeDetectorRef.detach();
    // setTimeout(() => this.tooltip.hide(200));


    const dialogRef = this.dialog.open(CadastrarComposicaoKitModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { editando: true, produtoKit: Object.assign({}, item) },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        item.idKit = result.idKit;
        item.proKit = result.proKit;
        item.proMP = result.proMP;
        item.qt = result.qt;
        item.produtoMP = result.produtoMP;
      }
    });
  }

  excluir(item: ProdutoKit) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o item?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.composicao.splice(this.composicao.indexOf(item), 1);
      }
    });
  }

  excluirTodasComposicoes() {
    swal({
      title: 'Deseja realmente excluir todas composições?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.composicao = [];
      }
    });
  }

}
